import React, { createContext, useContext } from 'react';

const ApiContext = createContext(null);

export const ApiProvider = ({ children }) => {
  const API_BASE_URL = 'https://backend.getbentobox.in/api';

  const submitBulkOrder = async (orderData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/bulk-orders`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });

      if (!response.ok) {
        throw new Error('Failed to submit bulk order');
      }

      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        return await response.json();
      }
      return await response.text();
    } catch (error) {
      console.error('Error submitting bulk order:', error);
      throw error;
    }
  };

  return (
    <ApiContext.Provider value={{ submitBulkOrder, API_BASE_URL }}>
      {children}
    </ApiContext.Provider>
  );
};

export const useApi = () => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error('useApi must be used within an ApiProvider');
  }
  return context;
};
